module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "m-t-0"
  }, [_vm._v("Trusted & Used By")])])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_DGMC.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_Netcare.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_CMSA.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_Medemass.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_Lancet.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_Ampath.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_Vericlaim.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_Promed.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_Healthrad.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row logos clearfix"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/brochure/professional/TrustBy_GoodX.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-lg"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3 text-center"
  }, [_c('p', [_vm._v("LogBox integrates with many platforms and billing systems. If you are a software provider in the medical field, please contact us to find out how we can partner together.")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-0"
  }, [_c('u', [_c('b', [_c('a', {
    attrs: {
      "href": "mailto:partner@logbox.co.za"
    }
  }, [_vm._v("Partner with us")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401ed8a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PartnerBranding.vue
// module id = 654
// module chunks = 5